import script from "./AdminCfoDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminCfoDashboard.vue?vue&type=script&setup=true&lang=ts"

import "./AdminCfoDashboard.vue?vue&type=style&index=0&id=201e1878&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-201e1878"]])

export default __exports__